import axios from "axios";

const API_BASE_URL = "https://suratizin-backend.trainertiu.workers.dev";

export const getNextFormNumber = async () => {
  const response = await axios.get(`${API_BASE_URL}/next-form-number`);
  return response.data.formNumber;
};

export const getDropdownValues = async () => {
  const response = await axios.get(`${API_BASE_URL}/dropdown-values`);
  return response.data;
};


export const submitForm = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/submit`, formData);
  return response.data;
};
